<div class="d-flex justify-content-between align-items-center mb-3">
  <h1 class="mb-0 fw-bold">{{ 'SKILL.TITLE' | translate }}</h1>
  <button class="btn btn-primary fw-bold bi-plus-lg" (click)="addNewSkill()">
    {{ 'SKILL.LIST.ADD_NEW' | translate }}
  </button>
</div>

<div>
  @if (errorMessage) {
<div class="alert alert-danger" HideAfter>
    <i class="bi-exclamation-circle mr-2"></i>
    {{ errorMessage }}
    <i class="bi-x" style="font-size: 2rem;" (click)="errorMessage = ''"></i>
  </div>
}
</div>

<div class="row skill-list-container">
  <div class="col">
    @if (isLoading) {
      <div class="d-flex justify-content-center align-items-center p-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">{{ 'COMMON.LOADING' | translate }}</span>
        </div>
        <span class="ms-2">{{ 'COMMON.LOADING' | translate }}</span>
      </div>
    } 
    @else {
      <table class="table table-hover table-striped rounded-3">
        <thead>
          <tr>
            <th scope="col">{{ 'COMMON.NAME' | translate }}</th>
            <th scope="col">{{ 'COMMON.PEOPLE' | translate }}</th>
            <th scope="col">{{ 'COMMON.CREATED_AT' | translate }}</th>
            <th scope="col">{{ 'COMMON.UPDATED_AT' | translate }}</th>
            <th scope="col">{{ 'COMMON.ACTIONS' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (skill of skills; track trackById($index, skill)) {
          <tr>
            <td><a [routerLink]="['/skills', skill.id]" class="fw-bold">{{ skill.name }}</a></td>
            <td>
              <div class="d-flex align-items-center flex-wrap gap-1">
                @if (skill.peoples && skill.peoples.length > 0){
                <app-avatar [personOrPeople]="skill.peoples" [grouped]="true" size="normal" shape="circle" class=" border-0"></app-avatar>
                <span class="text-muted fst-italic small fw-bold">({{ skill.peoples.length }})</span>
                }
                @else {
                  <span class="text-muted fst-italic">{{ 'TEAM.LIST.NO_MEMBERS' | translate }}</span>
                }
              </div>
            </td>
            <td class="date-cell">
              <span
                class="d-inline-flex align-items-center small text-muted"
                [attr.title]="skill.createdAt | date: 'dd MMM yyyy HH:mm'"
              >
                <i class="bi bi-calendar3 me-1"></i>
                {{ skill.createdAt | date: 'dd MMM yyyy' }}
              </span>
            </td>
            <td class="date-cell">
              <span
                class="d-inline-flex align-items-center small text-muted"
                [attr.title]="skill.updatedAt | date: 'dd MMM yyyy HH:mm'"
              >
                <i class="bi bi-calendar3 me-1"></i>
                {{ skill.updatedAt | date: 'dd MMM yyyy' }}
              </span>
            </td>
            <td>
              <div class="btn-group" role="group">
                <button title="{{ 'COMMON.EDIT' | translate }}" class="btn btn-outline-primary btn-sm rounded-pill border-0 me-1 editPerson" (click)="editSkill(skill)">
                  <i class="bi bi-pencil-fill"></i>
                </button>
                <button title="{{ 'COMMON.DELETE' | translate }}" class="btn btn-outline-danger btn-sm rounded-pill border-0 me-1 deletePerson" (click)="confirmDelete(skill)">
                  <i class="bi bi-trash-fill"></i>
                </button>
              </div>
            </td>
          </tr>
          }
        </tbody>
      </table>
      <app-pagination-controls
        [pagination]="pagination"
        [pageSizeOptions]="[5, 10, 20, 50]"
        (pageSizeChange)="onPageSizeChange($event)"
        (pageChange)="onPageChange($event)"
        >
      </app-pagination-controls>

      @if (skills.length === 0 && pagination.total_items === 0) {
        <div class="alert alert-info mt-3">
          {{ 'COMMONERROR.NO_DATA' | translate }}
        </div>
      }
    }
  </div>
</div>

<!-- Panneau latéral EN DEHORS de la row -->
<div class="sliding-panel" [class.show]="ShowForm">
  <h2>{{ skillToEdit?.id ? ('SKILL.LIST.EDIT_TITLE' | translate) : ('SKILL.LIST.ADD_TITLE' | translate) }}</h2>
  @if (formErrorMessage) {
<div class="alert alert-danger d-flex align-items-center" HideAfter>
    <i class="bi-exclamation-circle mr-2"></i>
    {{ formErrorMessage }}
    <i class="bi-x" style="font-size: 2rem;" (click)="formErrorMessage = ''"></i>
  </div>
}
  @if (skillToEdit) {
<form (ngSubmit)="onSubmit()" #skillForm="ngForm">
    <div class="mb-3">
      <label for="name" class="form-label">{{ 'COMMON.NAME' | translate }}</label>
      <input
        type="text"
        class="form-control"
        id="name"
        [(ngModel)]="skillToEdit!.name"
        name="name"
        required
        #name="ngModel"
      />
      @if (name.invalid && name.touched) {
<div>
        {{ 'SKILL.LIST.NAME_REQUIRED' | translate }}
      </div>
}
    </div>
    <div class="mb-3">
      <label for="description" class="form-label">{{ 'COMMON.DESCRIPTION' | translate }}</label>
      <textarea
        class="form-control"
        id="description"
        [(ngModel)]="skillToEdit!.description"
        name="description"
      ></textarea>
    </div>
    <div class="mt-3 d-flex justify-content-end">
      <button type="submit" class="btn btn-primary me-2" [disabled]="!name.valid">
        {{ skillToEdit.id ? ('SKILL.LIST.UPDATE' | translate) : ('SKILL.LIST.CREATE' | translate) }}
      </button>
      <button type="button" class="btn btn-secondary" (click)="cancelEdit()">
        {{ 'COMMON.CANCEL' | translate }}
      </button>
    </div>
  </form>
}
</div>

@if (showConfirmDialog) {
<app-confirm-dialog (confirm)="handleConfirm($event)"></app-confirm-dialog>
}